import { apiRequest } from '../utils'
const getAccount = (payload, stateOrRequest) => apiRequest('account/', null, 'GET', stateOrRequest)

export default getAccount
export { getAccount }



// WEBPACK FOOTER //
// ./src/server/api/Account/getAccount.ts